import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';
import { CrmSalesStatus } from './types';

const selectCrmSales = (state: RootState) => state.crmSales;

const selectCrmSalesTickets = createSelector(selectCrmSales, (state) => {
  return state;
});

const selectCrmSalesColumns = createSelector(selectCrmSales, (state) => {
  return state.columns;
});

const selectCrmSalesColumnByStatus = (status: CrmSalesStatus) =>
  createSelector(selectCrmSalesColumns, (columns) => {
    return columns[status];
  });

export const selectors = {
  selectCrmSalesTickets,
  selectCrmSalesColumns,
  selectCrmSalesColumnByStatus
};
